export const IS_TH = true;
